import { type JSX } from 'react/jsx-runtime';

export const ErrorIllustrationLight = (): JSX.Element => (
	<svg
		width="164"
		height="213"
		viewBox="0 0 164 213"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		aria-hidden="true"
	>
		<g clipPath="url(#clip0_1442_1682)">
			<rect
				width="163.28"
				height="212"
				transform="translate(0.649902 0.554688)"
				fill="white"
				fillOpacity="0.01"
			/>
			<path
				d="M95.4299 74.715L161.87 189.795C167.71 199.915 160.41 212.555 148.73 212.555H15.8499C4.16994 212.555 -3.13006 199.905 2.70994 189.795L69.1499 74.715C74.9899 64.595 89.5899 64.595 95.4299 74.715ZM87.8699 158.265L90.7499 113.915C91.0899 108.625 86.8899 104.135 81.5899 104.135C76.2799 104.135 72.0799 108.615 72.4299 113.915L75.3099 158.265C75.5299 161.575 78.2699 164.155 81.5899 164.155C84.8999 164.155 87.6499 161.575 87.8699 158.265ZM72.0299 181.805C72.0299 187.465 76.7899 191.905 82.4199 191.385C87.2699 190.935 91.1499 186.885 91.2499 182.015C91.3599 176.565 86.9399 172.075 81.5199 172.075C76.2899 172.065 72.0299 176.445 72.0299 181.805Z"
				fill="url(#paint0_linear_1442_1682)"
			/>
			<g opacity="0.6">
				<path
					opacity="0.6"
					d="M93.3498 27.7249L85.9398 1.0049C85.7698 0.384904 84.8698 0.424904 84.7498 1.0549L80.0898 26.1549L74.2898 25.0749C73.8498 24.9949 73.4698 25.4049 73.5898 25.8349L80.9998 52.5549C81.1698 53.1749 82.0698 53.1349 82.1898 52.5049L86.8498 27.4049L92.6498 28.4849C93.0998 28.5649 93.4698 28.1549 93.3498 27.7249Z"
					fill="#C1C7D0"
				/>
				<path
					opacity="0.6"
					d="M66.7699 42.365L55.8999 33.815C55.6799 33.635 55.3699 33.885 55.4899 34.145L61.0199 45.575L58.3599 46.865C58.1799 46.955 58.1599 47.195 58.3099 47.315L69.1799 55.865C69.3999 56.045 69.7099 55.795 69.5899 55.535L64.0599 44.105L66.7199 42.815C66.8899 42.735 66.9199 42.485 66.7699 42.365Z"
					fill="#C1C7D0"
				/>
			</g>
			<g opacity="0.6">
				<g opacity="0.6">
					<path
						opacity="0.6"
						d="M102.78 57.3048C102.57 57.3048 102.37 57.2448 102.19 57.1148C101.81 56.8348 101.68 56.3348 101.86 55.9248C101.62 55.1548 99.57 53.0748 98.32 51.8148C95.35 48.8048 93.39 46.8148 94.48 45.3248C95.57 43.8448 98.06 45.1048 101.83 47.0248C103.15 47.6948 105.18 48.7248 106.28 49.0548C105.64 48.1048 104.04 46.4748 103 45.4248C100.03 42.4148 98.07 40.4248 99.16 38.9348C100.24 37.4548 102.74 38.7148 106.5 40.6348C107.82 41.3048 109.84 42.3348 110.95 42.6648C110.31 41.7148 108.71 40.0948 107.67 39.0448C104.7 36.0348 102.74 34.0448 103.83 32.5548C104.91 31.0748 107.4 32.3348 111.17 34.2548C112.75 35.0548 115.35 36.3848 116.15 36.3848C116.49 36.0948 117 36.0648 117.39 36.3448C117.84 36.6748 117.93 37.2948 117.61 37.7448C116.52 39.2248 114.04 37.9648 110.27 36.0448C108.95 35.3748 106.93 34.3448 105.83 34.0148C106.47 34.9648 108.07 36.5848 109.11 37.6348C112.08 40.6448 114.04 42.6348 112.95 44.1248C111.87 45.6048 109.38 44.3448 105.61 42.4248C104.29 41.7548 102.26 40.7248 101.16 40.3948C101.8 41.3448 103.4 42.9648 104.44 44.0248C107.41 47.0348 109.37 49.0248 108.28 50.5148C107.19 51.9948 104.7 50.7348 100.93 48.8148C99.61 48.1448 97.58 47.1048 96.48 46.7848C97.12 47.7348 98.72 49.3648 99.76 50.4148C102.73 53.4248 104.69 55.4148 103.6 56.9048C103.39 57.1648 103.09 57.3048 102.78 57.3048Z"
						fill="#B3BAC5"
					/>
				</g>
			</g>
			<g opacity="0.6">
				<path
					opacity="0.6"
					d="M108.34 71.6249C107.99 71.6249 107.65 71.4349 107.46 71.1049C106.42 69.2249 105.24 67.0849 106.55 65.8949C107.86 64.6949 109.89 66.0749 112.04 67.5249C112.91 68.1149 114.3 69.0549 114.97 69.2349C114.85 68.5549 114.04 67.0849 113.52 66.1649C112.26 63.8949 111.07 61.7549 112.38 60.5549C113.69 59.3549 115.72 60.7349 117.87 62.1849C118.83 62.8349 120.41 63.9049 120.97 63.9249C121.38 63.6249 121.95 63.6749 122.3 64.0549C122.67 64.4649 122.65 65.0949 122.24 65.4649C120.93 66.6649 118.9 65.2949 116.75 63.8349C115.88 63.2449 114.49 62.3049 113.82 62.1249C113.94 62.8049 114.75 64.2749 115.27 65.1949C116.53 67.4649 117.72 69.6049 116.41 70.8049C115.1 72.0049 113.07 70.6249 110.92 69.1749C110.05 68.5849 108.66 67.6449 107.99 67.4649C108.11 68.1449 108.92 69.6049 109.21 70.1349C109.48 70.6149 109.3 71.2249 108.82 71.4949C108.67 71.5849 108.5 71.6249 108.34 71.6249Z"
					fill="#B3BAC5"
				/>
			</g>
			<g opacity="0.6">
				<path
					opacity="0.6"
					d="M54.02 68.7343C53.8 68.7343 53.58 68.6943 53.35 68.5943C51.71 67.9043 52.11 65.4843 52.54 62.9243C52.71 61.8843 52.99 60.2243 52.87 59.5443C52.3 59.9343 51.31 61.2943 50.69 62.1443C49.16 64.2343 47.7 66.2143 46.07 65.5243C45.56 65.3143 45.32 64.7243 45.54 64.2143C45.74 63.7343 46.27 63.4943 46.75 63.6443C47.27 63.4343 48.4 61.8943 49.09 60.9643C50.62 58.8743 52.07 56.8843 53.71 57.5843C55.35 58.2743 54.95 60.6943 54.52 63.2543C54.35 64.2943 54.07 65.9543 54.19 66.6343C54.76 66.2443 55.75 64.8843 56.37 64.0343C57.9 61.9443 59.35 59.9543 60.99 60.6543C62.62 61.3443 62.23 63.7443 61.88 65.8643C61.79 66.4043 61.28 66.7743 60.73 66.6943C60.19 66.6043 59.81 66.0943 59.9 65.5443C60 64.9543 60.27 63.3043 60.16 62.6243C59.59 63.0143 58.6 64.3743 57.98 65.2243C56.65 67.0143 55.39 68.7343 54.02 68.7343Z"
					fill="#B3BAC5"
				/>
			</g>
		</g>
		<defs>
			<linearGradient
				id="paint0_linear_1442_1682"
				x1="26.1692"
				y1="229.176"
				x2="138.408"
				y2="116.937"
				gradientUnits="userSpaceOnUse"
			>
				<stop stopColor="#C1C7D0" />
				<stop offset="0.297" stopColor="#C6CBD4" stopOpacity="0.8812" />
				<stop offset="0.6301" stopColor="#D3D7DE" stopOpacity="0.748" />
				<stop offset="0.9795" stopColor="#E9EBEF" stopOpacity="0.6082" />
				<stop offset="1" stopColor="#EBECF0" stopOpacity="0.6" />
			</linearGradient>
			<clipPath id="clip0_1442_1682">
				<rect width="163.28" height="212" fill="white" transform="translate(0.649902 0.554688)" />
			</clipPath>
		</defs>
	</svg>
);
